import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import NumberPicker from 'react-widgets/lib/NumberPicker';
import FormField from './FormField';
import QuickUpdatableComponent from './QuickUpdatableComponent';

class NumberInput extends QuickUpdatableComponent {
  render() {
    const {required, field, help, label, loading, disabled, defaultValue} = this.props;
    const value = field.value || defaultValue || 0;

    return (
        <FormField required={required} field={field} help={help} loading={loading} label={label}>
        <NumberPicker onChange={(value) => {
                          field.onChange({
                              target: {
                                  value,
                                  name: field.name,
                              },
                          });
                      }}
                      value={value}
                      defaultValue={defaultValue}
                      disabled={disabled}
                      id={field.name}
        />
        </FormField>);
  }
};

NumberInput.propTypes = {
  field: PropTypes.object.isRequired
}

export default NumberInput;